import { accountId } from '@gonfalon/constants/constants';

export function createStorageScope() {
  return `ld-account-${accountId() ?? 'anonymous'}`;
}
